// backend API environment variable
export default process.env.NODE_ENV === 'production' ? 'https://group6-backend.herokuapp.com' : 'http://localhost:3001'
